export enum SaleReportFormat {
  Quote,
  Cfdi,
  SummaryByProduct,
  SummaryByCategory,
  Recibo,
  Xml,
}
